"use client"

import { useState } from "react"
import { RxHamburgerMenu } from "react-icons/rx"
import { useUserContext } from "../../context/UserContext"
import Sidebar from "../../components/Common/Sidebar/Sidebar"
import AdminProfile from "../../components/AdminProfile/AdminProfile"
import MobileSideBar from "../../components/MobileSideBar/MobileSideBar"
import { FaCheck, FaBox, FaTruck, FaHome, FaChevronRight } from "react-icons/fa"
import { useLocation, useNavigate } from "react-router-dom"
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
dayjs.extend(advancedFormat)
import { GET_PRODUCT_QUERY } from "../../apollo/queries/getProduct"
import { useQuery, gql } from "@apollo/client"
import { LIST_TRANSACTIONS } from "../../apollo/queries/orders"

const STATUS_TO_STEP = {
  PENDING: 1,
  CONFIRMED: 2,
  IN_TRANSIT: 3,
  DELIVERED: 4,
  CANCELLED: 0,
}

// Progress is rendered via discrete segments; no percentage mapping needed

const normalizeStatus = (s) =>
  (s || "PENDING")
    .toString()
    .trim()
    .replace(/[\s-]+/g, "_")
    .toUpperCase()

function OrderTracking({ initialOrderData = {} }) {
  const { state } = useLocation()
  const navigate = useNavigate()
  const order = state?.item || initialOrderData
  const { reset } = useUserContext()
  const [isOpen, setIsOpen] = useState(false)
  const [toggle, setToggle] = useState(false)
  const [orderData] = useState(order)
  console.log(orderData, "orderData")

  const { data: transactionsData, loading: transactionsLoading } = useQuery(gql(LIST_TRANSACTIONS), {
    variables: {
      brandName: orderData?.brandName,
      limit: 200,
    },
    skip: !orderData?.brandName,
    fetchPolicy: "cache-and-network",
  })

  const transactionItem =
    (transactionsData?.listTransactions?.items || []).find(
      (t) => t?.orderId === orderData?.orderId || t?.orderId === orderData?.order || t?.id === orderData?.id,
    ) || orderData

  const { data: productData } = useQuery(GET_PRODUCT_QUERY, {
    variables: {
      brand: transactionItem?.brandName || orderData?.brandName,
      sk: transactionItem?.productId || orderData?.productId,
    },
    skip: !(
      (transactionItem?.brandName || orderData?.brandName) &&
      (transactionItem?.productId || orderData?.productId)
    ),
    fetchPolicy: "cache-first",
  })
  console.log(productData, "productData")

  const rawOrderStatus = transactionItem?.orderStatus
  const orderStatusArray = Array.isArray(rawOrderStatus)
    ? rawOrderStatus.filter(Boolean)
    : rawOrderStatus
      ? [rawOrderStatus]
      : []

  const statusTimeline = orderStatusArray.slice().sort((a, b) => new Date(a?.timestamp) - new Date(b?.timestamp))

  const latestOrderStatus = statusTimeline.length
    ? normalizeStatus(statusTimeline[statusTimeline.length - 1]?.status)
    : "PENDING"
  const computedStatus = normalizeStatus(latestOrderStatus)
  const currentStepIndex = STATUS_TO_STEP[computedStatus] || 0

  // No percentage calculation; progress uses discrete filled segments
  const isStepCompleted = (stepNumber) => {
    const currentStep = STATUS_TO_STEP[normalizeStatus(computedStatus)]
    return stepNumber < currentStep
  }

  const isStepActive = (stepNumber) => {
    const currentStep = STATUS_TO_STEP[normalizeStatus(computedStatus)]
    return stepNumber === currentStep
  }

  const getStatusDate = (key) => statusTimeline.find((s) => s?.status === key)?.timestamp || ""

  const steps = [
    {
      id: 1,
      key: "PENDING",
      label: "Pending",
      icon: FaBox,
      date:
        getStatusDate("PENDING") ||
        transactionItem?.createdAt ||
        transactionItem?.shopify?.orderDate ||
        orderData?.date ||
        "",
    },
    {
      id: 2,
      key: "CONFIRMED",
      label: "Confirmed",
      icon: FaTruck,
      date: getStatusDate("CONFIRMED") || "",
    },
    {
      id: 3,
      key: "IN_TRANSIT",
      label: "In Transit",
      icon: FaTruck,
      date: getStatusDate("IN_TRANSIT") || "",
    },
    {
      id: 4,
      key: "DELIVERED",
      label: "Delivered",
      icon: FaHome,
      date: getStatusDate("DELIVERED") || "",
    },
  ]

  return (
    <div className="w-full h-full flex font-montserrat">
      <Sidebar />
      <div className="admin-dashboard-card-section mx-auto order-section xl:ml-[290px] w-full xl:w-[80%]">
        <div className="w-[90%] lg:w-[95%] h-auto mx-auto mt-[45px] flex justify-between items-center">
          <div className="xl:hidden block" onClick={() => setToggle(!toggle)}>
            <RxHamburgerMenu className="w-5 h-5" />
          </div>
          {toggle && <MobileSideBar toggle={toggle} setToggle={setToggle} />}
          <AdminProfile setIsOpen={setIsOpen} isOpen={isOpen} />
        </div>

        <div className="max-w-4xl mx-auto px-4 py-8">
          <h1 className="admin-dashboard text-center">Track Your Order</h1>

          <div className="border border-solid border-gray-300 rounded-lg mb-8 p-4">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1 flex flex-col items-center">
                <h3 className="text-gray-500 text-sm font-medium mb-1">ORDER PLACED</h3>
                <p className="text-[#1f2937] text-base font-medium">
                  {dayjs(transactionItem?.createdAt || transactionItem?.shopify?.orderDate || orderData?.date).format(
                    "MMM Do YYYY [at] h:mm A",
                  )}
                </p>
              </div>
              <div className="flex-1 flex flex-col items-center">
                <h3 className="text-gray-500 text-sm font-medium mb-1">TOTAL</h3>
                <p className="text-[#1f2937] text-base font-medium">
                  {transactionItem?.totalPrice || orderData?.total}
                </p>
              </div>
              {/* <div className="flex-1 flex flex-col items-center">
                <h3 className="text-gray-500 text-sm font-medium mb-1">SHIP TO</h3>
                <p className="text-[#1f2937] text-base font-medium">
                  {orderData?.customer || transactionItem?.buyerId || "—"}
                </p>
              </div> */}
              <div className="flex-1 flex flex-col items-center">
                <h3 className="text-gray-500 text-sm font-medium mb-1">ORDER</h3>
                <p className="text-[#1f2937] text-base font-medium">{transactionItem?.orderId || orderData?.order}</p>
              </div>
            </div>
          </div>

          {/* Product details */}
          {productData?.getProduct && (
            <div className="border border-solid border-gray-300 rounded-lg mb-8 p-4">
              <div className="flex items-start gap-4">
                <img
                  src={productData.getProduct.photo || "/placeholder.svg"}
                  alt={productData.getProduct.productTitle}
                  className="w-24 h-24 object-cover rounded"
                />
                <div className="flex-1">
                  <p className="text-[#1f2937] text-base font-semibold m-0">
                    {(productData.getProduct.brandName || transactionItem?.brandName || "").trim()}{" "}
                    {productData.getProduct.productTitle ? `- ${productData.getProduct.productTitle}` : ""}
                  </p>
                  <p className="text-gray-600 text-sm m-0">
                    SKU: {productData.getProduct.saddlefitSku || productData.getProduct.sk}
                  </p>
                  <p className="text-gray-600 text-sm m-0">Price: {productData.getProduct.price}</p>
                </div>
              </div>
            </div>
          )}

          <div className="text-center mb-10">
            <h2 className="text-lg md:text-xl font-medium mb-1 text-[#1f2937]">
              Order Status:{" "}
              <span className="text-[#1f2937] font-semibold">
                {computedStatus === "IN_TRANSIT"
                  ? "In Transit"
                  : computedStatus?.charAt(0) + computedStatus?.slice(1).toLowerCase()}
              </span>
            </h2>
          </div>

          {/* Render the progress tracker only if order is not cancelled */}
          {computedStatus !== "CANCELLED" && (
            <>
              {/* Desktop Progress Tracker */}
              <div className="relative mt-16 hidden md:block px-6">
                <div className="absolute top-[21px] left-[20px] right-[20px] z-0">
                  <div className="flex items-center gap-0">
                    {[0, 1, 2, 3].map((seg, idx) => {
                      const filled = idx < currentStepIndex
                      return <div key={idx} className={`${filled ? "bg-[#1f2937]" : "bg-gray-300"} h-1 flex-1`} />
                    })}
                  </div>
                </div>

                <div className="relative flex justify-between z-10">
                  {steps.map(({ id, label, icon: Icon, date }) => {
                    const completed = isStepCompleted(id)
                    const active = isStepActive(id)
                    return (
                      <div key={id} className="flex flex-col items-center relative z-20">
                        <div
                          className={`w-10 h-10 rounded-full flex items-center justify-center mb-2 ${
                            completed || active ? "bg-[#1f2937]" : "bg-gray-200"
                          }`}
                        >
                          {completed ? (
                            <FaCheck className="h-4 w-4 text-white" />
                          ) : (
                            <Icon className={`h-4 w-4 ${active ? "text-white" : "text-gray-400"}`} />
                          )}
                        </div>
                        <p className="font-medium text-[16px]">{label}</p>
                        <p className="text-sm m-0 text-gray-500">
                          {date ? dayjs(date).format("MMM Do YYYY [at] h:mm A") : ""}
                        </p>
                      </div>
                    )
                  })}
                </div>
              </div>

              {/* Mobile Progress Tracker */}
              <div className="md:hidden mt-6 px-4">
                <div className="relative flex flex-col">
                  <div className="absolute left-4 top-4 bottom-4 z-0 flex flex-col">
                    {[0, 1, 2, 3].map((seg, idx) => {
                      const filled = idx < currentStepIndex
                      return <div key={idx} className={`w-0.5 ${filled ? "bg-[#1f2937]" : "bg-gray-300"} flex-1`} />
                    })}
                  </div>

                  {steps.map(({ id, label, icon: Icon, date }) => {
                    const completed = isStepCompleted(id);
                    console.log(completed, "completed")
                    const active = isStepActive(id)
                    return (
                      <div key={id} className="flex items-center mb-10 relative z-10">
                        <div
                          className={`w-8 h-8 rounded-full flex items-center justify-center z-10 ${
                            completed || active ? "bg-[#1f2937]" : "bg-gray-200"
                          }`}
                        >
                          {completed ? (
                            <FaCheck className="h-4 w-4 text-white" />
                          ) : (
                            <Icon className={`h-4 w-4 ${active ? "text-white" : "text-gray-400"}`} />
                          )}
                        </div>
                        <div className="ml-4">
                          <p className="font-medium text-sm">{label}</p>
                          <p className="text-xs text-gray-500">
                            {date ? dayjs(date).format("MMM Do YYYY [at] h:mm A") : ""}
                          </p>
                        </div>
                        {active && (
                          <div className="absolute -right-1 top-1/2 -translate-y-1/2">
                            <FaChevronRight className="h-4 w-4 text-[#1f2937]" />
                          </div>
                        )}
                      </div>
                    )
                  })}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default OrderTracking
